/**
 * @generated SignedSource<<8510b647dd94cd1ab7042f77e46fa7ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": "successPlaceholder",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookletsDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Booklet",
        "kind": "LinkedField",
        "name": "deleteBooklet",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookletsDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Booklet",
        "kind": "LinkedField",
        "name": "deleteBooklet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "26e03cae62592fca48717320e35dbfd2",
    "id": null,
    "metadata": {},
    "name": "BookletsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation BookletsDeleteMutation(\n  $id: ID!\n) {\n  deleteBooklet(id: $id) {\n    successPlaceholder: id\n    id\n  }\n}\n"
  }
};
})();

node.hash = "310d1d6d531f607d58cde3905ed4ff40";

module.exports = node;
